import { Component, computed, input, model, output, ChangeDetectionStrategy } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ActionsSummaryData } from '../../models/dispatch-actions.model';

export type { ActionsSummaryData };

/**
 * Actions Summary Dialog Component
 * Displays detailed results of dispatch actions execution
 * Matches legacy ActionsSummary popup (dispatch_services.js line 4820-4870)
 */
@Component({
  selector: 'app-actions-summary-dialog',
  imports: [DialogModule, ButtonModule],
  templateUrl: './actions-summary-dialog.component.html',
  styleUrl: './actions-summary-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionsSummaryDialogComponent {
  visible = model<boolean>(false);

  data = input<ActionsSummaryData | null>(null);
  /** Optional info message shown above the stats (e.g. address sync notification). */
  infoMessage = input<string | null>(null);
  /** Label for the dismiss button. */
  buttonLabel = input<string>('OK');

  dismissed = output<void>();

  countMessage = computed(() => {
    const d = this.data();
    if (!d) return '';
    return `Finished ${d.totalActions} action(s) (${d.successCount} success, ${d.failCount} fail)`;
  });

  getErrorDetail(action: string): string | undefined {
    return this.data()?.errorDetails?.get(action);
  }

  onClose(): void {
    this.visible.set(false);
    this.dismissed.emit();
  }
}
